import { root } from '../../../../store/constants';

export const isFreeVersionSelector = () => {
    return Boolean(root.App.Helpers.PaypalHelper.isUserAllowFreeVersion());
};
